import React, { Component } from 'react'
import {Col, Glyphicon, Popover, OverlayTrigger, ListGroupItem} from 'react-bootstrap'
import { Link } from 'react-router'
import {observer, inject} from 'mobx-react'
import {listModes} from './IdeaList'
import StoredListItem from '../components/StoredListItem'
import {listFilterModes} from '../stores/IdeaStore'
import './css/IdeaStorage.css'
import Logger from '../stores/Logger'

class IdeaStorage extends Component {

    constructor(props) {
        super(props)
        this.state = {
            searchBarText: '',
        }
        this.changeFilter = this.changeFilter.bind(this)
    }

    componentWillMount(){
        const {stores} = this.props
        const {routingStore} = stores
        const {push} = routingStore
        push('/idea-storage/')
    }
    shouldComponentUpdate(){
        const {store} = this.props.stores
        const {
            loadingIdeas,
        } = store
        return !loadingIdeas
    }
    componentWillReceiveProps(nextProps){
        const {params} = nextProps
        if (params.ideaGroup && this.props.stores.prefStore.loadedPrefs === true){
            this.updateIdeasViewed(params.ideaGroup)
        }
    }
    componentDidMount(){
        // console.log('componentDidMount',this.props)
        const {stores} = this.props
        const {store, authStore, notificationStore} = stores
        // console.log('componentDidMount()')
        this.unwatchAuth = authStore.watchAuth(user => {
            if (user){
            //    console.log('calling loadIdeas')
                notificationStore.saveMessagingDeviceToken()
            }else{
                console.log('logged out!')
                store.logout()
            }
        }, error => {
           console.log('watchAuth error: '+JSON.stringify(error))
        })
    }
    componentWillUnmount() {
       if (this.unwatchAuth) {
           this.unwatchAuth()
           this.unwatchAuth = null
       }
    }
    updateIdeasViewed(ideaGroup){
        this.props.stores.prefStore.ideaGroup = ideaGroup
        this.props.stores.prefStore.storeUserPreferences()
        Logger.trackEvent('updateIdeasViewed','ideaGroup',ideaGroup)
    }
    changeSearchBarText(e){
        this.setState({searchBarText: e.target.value})
    }
    handleSearchClick(){
        if (this.state.searchBarText !== undefined && this.state.searchBarText !== ''){
            this.props.stores.prefStore.storedListSearchText = this.state.searchBarText
            this.props.stores.prefStore.storeUserPreferences()
            this.setState({searchBarText: ''})
            Logger.trackEvent('filterIdeas','filterString',this.state.searchBarText)
        }
    }
    filter(e) {
        if(e.key === 'Enter') {
            if (this.state.searchBarText !== undefined && this.state.searchBarText !== ''){
                this.props.stores.prefStore.storedListSearchText = this.state.searchBarText
                this.props.stores.prefStore.storeUserPreferences()
                this.setState({searchBarText: ''})
                Logger.trackEvent('filterIdeas','filterString',this.state.searchBarText)
            }
        }
    }
    showCompact(e){
        this.props.stores.prefStore.viewMode = listModes.compact
        this.props.stores.prefStore.storeUserPreferences()
        Logger.trackEvent('showCompact')
        this.doUpdate()
    }
    showCard(e){
        this.props.stores.prefStore.viewMode = listModes.card
        this.props.stores.prefStore.storeUserPreferences()
        Logger.trackEvent('showCard')
        this.doUpdate()
    }
    changeFilter(filterText){
        const {stores} = this.props
        const {store} = stores
        store.handleStoredFilterChange(filterText)
    }
    showNonTeamIdeas(showNonTeamIdeas){
        if(showNonTeamIdeas === false){
            this.props.stores.prefStore.showNonTeamStoredIdeas = 3
        } else {
            this.props.stores.prefStore.showNonTeamStoredIdeas = false
        }
        this.props.stores.prefStore.storeUserPreferences()
    }
    render() {

        const {store, authStore, prefStore} = this.props.stores
        const {
            filter,
            filteredStoredResponsibleIdeas,
            filteredAllStoredIdeas,
            filteredWorkOnStoredIdeas,
            filteredTeamSharedStoredIdeaArray,
            responsibleStoredIdeaArray,
            workOnStoredIdeaArray,
            allStoredIdeas,
            teamSharedStoredIdeaArray,
            loadingIdeas,
        } = store

        let team = authStore.auth.primaryTeam

        let filteredIdeasToShow, unfilteredIdeasToShow, noIdeasText
        filteredIdeasToShow = []

        let listFilter = prefStore.storedListFilterMode
        let listSearch = prefStore.storedListSearchText
        let involveNonTeamIdeas = prefStore.showNonTeamStoredIdeas

        switch (listFilter) {
            case listFilterModes.allIdeas:
                filteredIdeasToShow = filteredAllStoredIdeas
                unfilteredIdeasToShow = allStoredIdeas
                noIdeasText =
                    (<div>
                        <h2>You have no stored ideas in PRE.DO yet.</h2>
                    </div>)
                break
            case listFilterModes.workOn:
                filteredIdeasToShow = filteredWorkOnStoredIdeas
                unfilteredIdeasToShow = workOnStoredIdeaArray
                noIdeasText =
                    (<div>
                        <h2>You have no stored ideas you work on in PRE.DO yet.</h2>
                    </div>)
                break
            case listFilterModes.teamIdeas:
                filteredIdeasToShow = filteredTeamSharedStoredIdeaArray
                unfilteredIdeasToShow = teamSharedStoredIdeaArray
                noIdeasText =
                    (<div>
                        <h2>Your team has no stored ideas in PRE.DO yet.</h2>
                    </div>)
                break
            case listFilterModes.responsibleFor:
            default:
                filteredIdeasToShow = filteredStoredResponsibleIdeas
                unfilteredIdeasToShow = responsibleStoredIdeaArray
                noIdeasText =
                    (<div>
                        <h2>You have no stored ideas you are responsible for in PRE.DO yet.</h2>
                    </div>)
                break
        }

        let popoverFilter = (
            <Popover className='filterPopover' id='popover-positioned-bottom'>
                <div className='filterPopoverLeft'>
                    <span>
                        My involvement
                    </span>
                </div>

                <div className='filterPopoverRight'>
                    <div className='bg'>
                        <div onClick={() => this.changeFilter(listFilterModes.responsibleFor)} className='chiller_cb'>
                            <input id='myCheckbox' type='checkbox' readOnly checked={listFilter === listFilterModes.responsibleFor}/>
                            <label style={{fontWeight: 500, cursor: 'pointer'}}>Ideas I am responsible for</label>
                            <span></span>
                        </div>
                    </div>

                    <div style={{ marginTop: 10 + 'px' }} className='bg'>
                        <div onClick={() => this.changeFilter(listFilterModes.workOn)} className='chiller_cb'>
                        <input id='myCheckbox' type='checkbox' value={listFilterModes.workOn} readOnly checked={listFilter === listFilterModes.workOn}/>
                            <label style={{fontWeight: 500, cursor: 'pointer'}}>Ideas I work on</label>
                            <span></span>
                        </div>
                    </div>

                    {(team && team.hasOwnProperty('members') > 0) &&
                        <div style={{ marginTop: 10 + 'px' }} className='bg'>
                            <div onClick={() => this.changeFilter(listFilterModes.teamIdeas)} className='chiller_cb'>
                                <input id='myCheckbox' type='checkbox' readOnly checked={listFilter === listFilterModes.teamIdeas}/>
                                <label style={{fontWeight: 500, cursor: 'pointer'}}>Ideas I do not work on</label>
                                <span></span>
                            </div>
                        </div>
                    }
                    {(team && team.hasOwnProperty('members') > 0) &&
                        <div>
                            <hr></hr>
                            <div style={{ marginTop: 10 + 'px' }} className='bg'>
                                <div onClick={() => this.showNonTeamIdeas(involveNonTeamIdeas)} className='chiller_cb'>
                                    <input id='myCheckbox' type='checkbox' readOnly checked={involveNonTeamIdeas === false}/>
                                    <label style={{fontWeight: 500, cursor: 'pointer'}}>Show team ideas only</label>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </Popover>
        )

        let acceptedArray = null
        let acceptedCount = null

        let rejectedArray = null
        let rejectedCount = null

        if(filteredIdeasToShow !== null){
            acceptedArray = filteredIdeasToShow.filter(idea => idea.status === 'Accepted')
            acceptedCount = acceptedArray.length
            rejectedArray = filteredIdeasToShow.filter(idea => idea.status === 'Rejected')
            rejectedCount = rejectedArray.length
        }

        return (
            <div className='ideaStorageContainer'>
                <div className='ideaStorageFilter'>
                    {loadingIdeas !== true &&
                        <Col className='searchFilterContainer'>
                            <h2 style={{marginTop: 5+'px', marginBottom: 30+'px'}}>Idea storage</h2>
                            <div className='ideaListSearchBar'>
                            {store.isLoggedIn &&
                                <div className='searchContainer'>
                                    <input className='searchInput' style={{border: '1px solid #ccc'}} type='text' placeholder='Search' value={this.state.searchBarText} onKeyPress={this.filter.bind(this)} onChange={this.changeSearchBarText.bind(this)}/>
                                    <Glyphicon className='searchInputIcon' glyph='search' onClick={() => this.handleSearchClick()}/>
                                </div>
                            }
                            </div>
                            <div className='ideaListFilter'>
                                <OverlayTrigger className='popoverTrigger' trigger='click' rootClose placement='bottom' overlay={popoverFilter}>
                                    <div className='filterContainer'>
                                        <span>Filter ideas by </span>
                                        <Glyphicon className='filterIcon' glyph='filter'/>
                                    </div>
                                </OverlayTrigger>
                            </div>
                            {listFilter > listFilterModes.allIdeas &&
                                <div className='filterTagContainer'>
                                        <div className='filterTags'>
                                            <div onClick={() => store.deleteStoredFilterTag()} className='deleteFilterTagButton'>
                                                x
                                            </div>
                                            {store.returnStoredFilterTag()}
                                        </div>

                                </div>
                            }
                            <div className='filterTagContainer'>
                                {(listSearch !== null && listSearch !== '') &&
                                    <div className='filterTags'>
                                        <div onClick={() => store.deleteStoredSearchTag()} className='deleteFilterTagButton'>
                                            x
                                        </div>
                                        "{listSearch}"
                                    </div>
                                }
                            </div>
                        </Col>
                    }
                    <div >
                        {store.online &&
                            <div className='loadingIdeasText'>
                                {loadingIdeas ? (
                                    <div>
                                        <h2>Loading ideas...</h2>
                                    </div>
                                ) : (
                                        <div>
                                            {unfilteredIdeasToShow.length === 0 &&
                                                <div style={{ marginBottom: 20 + 'px' }}>
                                                    {noIdeasText}
                                                </div>
                                            }
                                            {((filteredIdeasToShow.length === 0) && (unfilteredIdeasToShow.length > 0)) &&
                                                <div className='storedSearchNotFound'>
                                                    <h4>Your search - <em>{filter}</em> - did not match any ideas.</h4>
                                                </div>
                                            }
                                        </div>
                                    )}
                            </div>
                        }
                    </div>
                </div>

                <div className='ideaStorageLeftContainer'>
                    {filteredIdeasToShow !== null &&
                        <div>
                            {filteredIdeasToShow.length > 0 &&
                            <div>
                                <h3 className='storedAcceptedText'>Accepted</h3>
                                <h4 className='acceptedCount'>{acceptedCount}
                                    {(acceptedCount > 1 || acceptedCount < 1) &&
                                        <span> ideas</span>
                                    }
                                    {(acceptedCount > 0 && acceptedCount < 2) &&
                                        <span> idea</span>
                                    }
                                </h4>
                            </div>
                            }
                            {filteredIdeasToShow.map((idea) =>
                                <div key={idea.key + idea.status}>
                                    {idea.status === 'Accepted' &&
                                        <ListGroupItem key={idea.key} className='filteredStoredListItem'>
                                            <Link style={{textDecoration: 'none'}} className='filteredLinkItem' to={{ pathname: '/idea/'+ idea.key +'/view' }}>
                                                <StoredListItem item={idea} showFields={'owner,rec,tags'}/>
                                            </Link>
                                        </ListGroupItem>
                                    }
                                </div>,
                            )}
                        </div>
                    }
                </div>

                <div className='ideaStorageRightContainer'>
                    {filteredIdeasToShow !== null &&
                        <div>
                            {filteredIdeasToShow.length > 0 &&
                            <div>
                                <h3 className='storedRejectedText'>Rejected</h3>
                                <h4 className='rejectedCount'>{rejectedCount}
                                    {(rejectedCount > 1 || rejectedCount < 1) &&
                                        <span> ideas</span>
                                    }
                                    {(rejectedCount > 0 && rejectedCount < 2) &&
                                        <span> idea</span>
                                    }
                                </h4>
                            </div>
                            }
                            {filteredIdeasToShow.map((idea) =>
                                <div key={idea.key + idea.status}>
                                    {idea.status === 'Rejected' &&
                                        <ListGroupItem key={idea.key} className='filteredStoredListItem'>
                                            <Link style={{textDecoration: 'none'}} className='filteredLinkItem' to={{ pathname: '/idea/'+ idea.key +'/view' }}>
                                                <StoredListItem item={idea} showFields={'owner,rec,tags'}/>
                                            </Link>
                                        </ListGroupItem>
                                    }
                                </div>,
                            )}
                        </div>
                    }
                </div>

                <div className='cardEmptySpace'></div>
            </div>
        )
    }
}

export default inject("stores")(observer(IdeaStorage))




// WEBPACK FOOTER //
// ./src/containers/IdeaStorage.js